import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.as{justify-content:center;}.ssr-plugin'
import '.ih{min-height:100vh;}.ssr-plugin'
import '.v{background-color:var(--palette-white);}.ssr-plugin'
import '.ea{padding:2rem;}.ssr-plugin'
import '.e4{gap:2rem;}.ssr-plugin'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'
import { useTranslations } from '@i18n/useLanguage'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const MaintenancePage = ({ message }: { message?: string }) => {
  const translations = useTranslations().app

  return (
    <div className="a b t as ih v ea e4"
    >
      <PageSeo
        pageTitle="CrowdBuilding"
        description={message || translations.landingPage.maintenanceMessage}
        noindex
      />
      <Image
        src={fullLogo}
        alt="CrowdBuilding"
        resizeHeight={48}
        style={{ height: '3rem' }}
      />
      <Text.Large
        style={{
          textAlign: 'center',
          maxWidth: '36rem',
        }}
      >
        {message || translations.landingPage.maintenanceMessage}
      </Text.Large>
    </div>
  )
}
